import React from "react";

import { useFlightingStore } from "@/pages/flighting/store/useFlightingStore";
import { ChartToggle } from "@/pages/flighting/types/common";
import { ToggleButton } from "@/Components/v2/atoms/Button/ToggleButton";
import { useConfig } from "@/hooks/useConfig";

const REVENUE_OPTIONS = Object.values(ChartToggle);

const RevenueToggle: React.FC = () => {
  const { config } = useConfig();
  const { revenueLabel } = config;
  const revenueType: ChartToggle[] = useFlightingStore((state) => state.chart.toggles);
  const setToggles = useFlightingStore((state) => state.setToggles);

  const handleChange = (option: ChartToggle) => {
    if (revenueType.includes(option)) {
      setToggles(revenueType.filter((item) => item !== option));
      return;
    }
    setToggles([...revenueType, option]);
  };

  return (
    <>
      {REVENUE_OPTIONS.map((option) => (
        <ToggleButton
          onClick={() => handleChange(option)}
          selected={revenueType.includes(option)}
          key={option}
          value={option}
          sx={{
            padding: "0.5rem 1rem",
            width: "inherit",
          }}
        >
          {option === ChartToggle.REVENUE ? revenueLabel : option}
        </ToggleButton>
      ))}
    </>
  );
};

export default RevenueToggle;
